export default __webpack_public_path__ + "static/media/mobile_venue_calendar.1d21ec96.webp";